import { render, staticRenderFns } from "./SelfRegistrationLog.vue?vue&type=template&id=383096e0&scoped=true&"
import script from "./SelfRegistrationLog.vue?vue&type=script&lang=js&"
export * from "./SelfRegistrationLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383096e0",
  null
  
)

export default component.exports